import { roundTo } from '../../utils/roundTo.js';
export const calculateResult = (value, rate, precision) => {
    const result = Number(formatValue(value)) * Math.pow(rate, precision ? -1 : 1);
    return Number.isInteger(result) ? result : roundTo(result);
};
export const formatValue = (value) => value.replace(/[^\d.,]/g, '').replace(',', '.');
//# sourceMappingURL=calculateResult.js.map